import { render, staticRenderFns } from "./nutritiousDiningMenuWeek.vue?vue&type=template&id=0a2eaef1&scoped=true&"
import script from "./nutritiousDiningMenuWeek.vue?vue&type=script&lang=js&"
export * from "./nutritiousDiningMenuWeek.vue?vue&type=script&lang=js&"
import style0 from "./nutritiousDiningMenuWeek.vue?vue&type=style&index=0&id=0a2eaef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2eaef1",
  null
  
)

export default component.exports